const $doc = $(document)

$doc.on('click', '.js-btn-scroll', function (e) {
  e.preventDefault()

  const $this = $(this)
  const href = $this.attr('href')

  const targetTop = $($this.data('js-target-scroll')).offset().top
  const $header = $('.js-header')
  let headerH = 0

  if ($header.length) {
    headerH = $header.outerHeight()
  };

  $('body,html').animate({
    scrollTop: targetTop - headerH
  }, 700)
})
